import React from 'react'

const Extra_header = () => {
  return (
    // <div style={{"display":'flex',"justifyContent":'space-around'}}>
    //     {/* <h6>Activity Type</h6>
    //     <h6>Activity Name</h6>
    //     <h6>Duration</h6> */}
    // </div>
    <div>
      
    </div>
  )
}

export default Extra_header